import { useRef } from "react";
import { isEqual } from "lodash";

export default function useDeepMemo<V>(value: V): V {
  const ref = useRef(value);
  if (!isEqual(value, ref.current)) ref.current = value;
  return ref.current;
}
